<template>
<MainTemplate>
    <v-container>
        <v-row>
            <v-col md="6">
                <projectStartCardVue/>
            </v-col>

            <v-col md="6">
                <projectAlertCardVue/>
            </v-col>
        </v-row>
    </v-container>
</MainTemplate>
</template>

<script>
import MainTemplate from "../../components/main-template.vue"
import projectStartCardVue from "./cards/project-start-card.vue"
import projectAlertCardVue from "./cards/project-alert-card.vue"

export default {
    name: 'home',
    components: {
      MainTemplate,
      projectStartCardVue,
      projectAlertCardVue
    }
}
</script>

<style>
.v-card__title.card-home-title {
    font-weight: 500;
    color: #3e3e3e;
    font-size: 19px;
    font-family: 'Montserrat', sans-serif;
}
</style>